import { render, staticRenderFns } from "./PaddleVersion.vue?vue&type=template&id=301d2735&"
import script from "./PaddleVersion.vue?vue&type=script&lang=js&"
export * from "./PaddleVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports